<template>
  <b-card
    v-if="data"
    class="card-tiny-line-stats"
    body-class="pb-50"
  >
    <h6>Acessos totais</h6>
    <h2 class="font-weight-bolder mb-1">
      {{ data.access }}
    </h2>
    <!-- chart -->
    <b-overlay
      :show="height === 0"
      rounded="sm"
    >
      <vue-apex-charts
        :height="`${height}%`"
        :options="statisticsProfit.chartOptions"
        :series="dataWatcher"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import Vue from 'vue'

const $trackBgColor = '#EBEBEB'

export default {
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      height: 0,
      dataWatcher: [0],
      statisticsProfit: {
        chartOptions: {
          chart: {
            type: 'line',
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: false,
            },
          },
          grid: {
            borderColor: $trackBgColor,
            strokeDashArray: 5,
            xaxis: {
              lines: {
                show: true,
              },
            },
            yaxis: {
              lines: {
                show: false,
              },
            },
            padding: {
              top: -30,
              bottom: -10,
            },
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          colors: [$themeColors.info, $themeColors.danger, $themeColors.success],
          markers: {
            size: 2,
            colors: $themeColors.info,
            strokeColors: $themeColors.info,
            strokeWidth: 2,
            strokeOpacity: 1,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [
              {
                seriesIndex: 0,
                dataPointIndex: 5,
                fillColor: '#ffffff',
                strokeColor: $themeColors.info,
                size: 5,
              },
            ],
            shape: 'circle',
            radius: 2,
            hover: {
              size: 3,
            },
          },
          xaxis: {
            labels: {
              show: true,
              style: {
                fontSize: '0px',
              },
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
      },
    }
  },
  watch: {
    dataWatcher() {
      Vue.set(this.dataWatcher, this.data.series)
      setTimeout(() => {
        this.height = 70
      }, 1000)
    }
  },
  mounted() {
    this.data.series.forEach(element => {
      Vue.set(this.dataWatcher, 0, element)
    })
  }
}
</script>
